/* ==========================================================================
   CDS Cart Drawer Cross-sell - Variant Selector
   Gestion des variantes dans le cross-sell du cart drawer
   ========================================================================== */

(function() {
  'use strict';

  // Fonction pour formater les prix
  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = parseInt(cents.replace(/[^0-9]/g, ''));
    }
    
    // Utiliser le format du thème si disponible
    if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    
    // Fallback simple - format EUR
    const amount = (cents / 100).toFixed(2);
    return amount.replace('.', ',') + '€';
  }

  // Initialiser les sélecteurs de variantes
  function initBuywithVariants() {
    const selects = document.querySelectorAll('.js-buywith-variant-select');
    
    selects.forEach(function(select) {
      // Éviter de réinitialiser
      if (select.dataset.initialized === 'true') return;
      select.dataset.initialized = 'true';
      
      select.addEventListener('change', function(e) {
        const card = this.closest('.product-grid-buywith');
        if (!card) return;
        
        const selectedOption = this.options[this.selectedIndex];
        if (!selectedOption) return;
        
        const variantId = selectedOption.value;
        const price = selectedOption.dataset.price;
        const comparePrice = selectedOption.dataset.comparePrice;
        const available = selectedOption.dataset.available === 'true';
        const imageUrl = selectedOption.dataset.image;
        
        // Mettre à jour le prix
        const priceEl = card.querySelector('.js-buywith-price-current');
        const comparePriceEl = card.querySelector('.js-buywith-price-compare');
        const priceWrapper = card.querySelector('.js-buywith-price');
        
        if (priceEl && price) {
          priceEl.textContent = formatMoney(price);
        }
        
        if (comparePriceEl) {
          if (comparePrice && parseInt(comparePrice) > parseInt(price)) {
            comparePriceEl.textContent = formatMoney(comparePrice);
            comparePriceEl.style.display = 'inline';
            if (priceWrapper) priceWrapper.classList.add('product-card__pricesale');
          } else {
            comparePriceEl.style.display = 'none';
            if (priceWrapper) priceWrapper.classList.remove('product-card__pricesale');
          }
        }
        
        // Mettre à jour le bouton
        const addBtn = card.querySelector('.js-buywith-add');
        const btnText = card.querySelector('.js-buywith-btn-text');
        
        if (addBtn) {
          addBtn.dataset.id = variantId;
          
          if (available) {
            addBtn.classList.remove('disabled');
            if (btnText) {
              // Récupérer le texte depuis les traductions du thème ou utiliser le fallback
              var addToText = 'Ajouter';
              if (window.theme && window.theme.strings && window.theme.strings.addTo) {
                addToText = theme.strings.addTo;
              }
              btnText.textContent = '+ ' + addToText;
            }
          } else {
            addBtn.classList.add('disabled');
            if (btnText) {
              // Récupérer le texte depuis les traductions du thème ou utiliser le fallback
              var soldOutText = 'Épuisé';
              if (window.theme && window.theme.strings && window.theme.strings.soldOut) {
                soldOutText = theme.strings.soldOut;
              }
              btnText.textContent = soldOutText;
            }
          }
        }
        
        // Mettre à jour l'image si disponible
        if (imageUrl) {
          const imgEl = card.querySelector('.js-buywith-image');
          if (imgEl) {
            imgEl.src = imageUrl;
            imgEl.dataset.src = imageUrl;
          }
        }
      });
    });
  }

  // Observer pour détecter quand le contenu du drawer change
  function observeDrawerContent() {
    const drawerContent = document.querySelector('.drawer-crossell');
    if (!drawerContent) return;
    
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          // Réinitialiser les sélecteurs après chaque mise à jour du contenu
          setTimeout(initBuywithVariants, 100);
        }
      });
    });
    
    observer.observe(drawerContent, {
      childList: true,
      subtree: true
    });
  }

  // Initialiser au chargement de la page
  document.addEventListener('DOMContentLoaded', function() {
    initBuywithVariants();
    observeDrawerContent();
  });

  // Réinitialiser quand le mini cart est mis à jour
  // Écouter les événements de mise à jour du thème
  document.addEventListener('cart:updated', initBuywithVariants);
  
  // Exposer la fonction pour appel manuel si nécessaire
  window.initBuywithVariants = initBuywithVariants;

})();
